const DATA_PLACEHOLDER = () => ({
  letterId: "1234",
  caccname: "华夏银行",
  type: "确认函/外部",
  project: "SZSH1000339812",
  offer: {
    talentList: [
      {
        talentName: "张三",
      },
    ],
    // TODO 3 个 数值
  },
  onboard: {
    talentList: [
      {
        talentName: "李四",
      },
    ],
    // TODO 3 个 数值
  },
});

export default {
  namespaced: true,
  state: () => ({
    letterDetail: undefined,
  }),
  getters: {
    offerTalents: (state) => state.letterDetail && state.letterDetail.offer,
    onboardTalents: (state) => state.letterDetail && state.letterDetail.onboard,
  },
  mutations: {
    setLetterDetail: (state, value) => {
      state.letterDetail = value;
    },
  },
  //调用mutations方法，可以使用异步方法
  actions: {
    updateDetail: async ({ commit }, form) => {
      // TODO AJAX
      form;
      const data = DATA_PLACEHOLDER();

      commit("setLetterDetail", data);
    },
  },
};
